/**
 *  ・定義ファイル名
 *    入力チェック定義ファイル
 *  ・概要
 *    各業務フローにて実施される入力チェックをまとめたファイル
 *    各プロセスのステータス毎に記述する
 */
interface Rules {
  id: string
  rule: string[]
  referenceField?: {
    id: string
    rule: string
    addValue?: boolean
  }[]
  referenceMasterOptions?: {
    define: string
    rule: string
  }[]
}

/**
 * お知らせ情報マスタルール
 * ※個別ルール仕様が追加された場合はここに追加する
 */
export const informationRules: { [k: string]: { [k: string]: Rules[] } } = {
  'information_regist': {
    'information_regist': []
  },
  'information_edit': {
    'information_valid_update': [],
    'information_valid_delete': []
  }
};

/**
 * 顧客マスタルール
 */
export const customerRules: { [k: string]: { [k: string]: Rules[] } } = {
  'customer_regist': {
    'customer_regist': [
      {
        //郵便番号書式チェック
        id: 'postal_code',
        rule: ['wrong_format_for_postal_code']
      },
      {
        //電話番号書式チェック
        id: 'telephone_number',
        rule: ['wrong_format_for_number_and_hyphen']
      },
      {
        //携帯電話番号書式チェック
        id: 'cell_phone_number',
        rule: ['wrong_format_for_number_and_hyphen']
      },
      {
        // 顧客名全角チェック
        id: 'customer_name',
        rule: ['fullwidth_only']
      },
      {
        // 顧客名カナ全角カナチェック
        id: 'customer_kana',
        rule: ['fullwidth_katakana_and_space_only']
      },
      {
        // 町村丁番地全角チェック
        id: 'machimura_street_address',
        rule: ['fullwidth_only']
      },
      {
        // ビル建物名全角チェック
        id: 'building_name',
        rule: ['fullwidth_only']
      },
      {
        // 顧客担当者名全角チェック
        id: 'manager',
        rule: ['fullwidth_only']
      },
      {
        // 顧客担当者メールアドレスチェック
        id: 'manager_email',
        rule: ['email']
      },
      {
        // 法人番号チェック(数値13桁固定)
        id: 'corporate_number',
        rule: ['numeric|corporate_number_lengthCheck:13']
      }
    ]
  },
  'customer_edit': {
    'customer_valid_update': [
      {
        //郵便番号書式チェック
        id: 'postal_code',
        rule: ['wrong_format_for_postal_code']
      },
      {
        //電話番号書式チェック
        id: 'telephone_number',
        rule: ['wrong_format_for_number_and_hyphen']
      },
      {
        //携帯電話番号書式チェック
        id: 'cell_phone_number',
        rule: ['wrong_format_for_number_and_hyphen']
      },
      {
        // 顧客名全角チェック
        id: 'customer_name',
        rule: ['fullwidth_only']
      },
      {
        // 顧客名カナ全角カナチェック
        id: 'customer_kana',
        rule: ['fullwidth_katakana_and_space_only']
      },
      {
        // 町村丁番地全角チェック
        id: 'machimura_street_address',
        rule: ['fullwidth_only']
      },
      {
        // ビル建物名全角チェック
        id: 'building_name',
        rule: ['fullwidth_only']
      },
      {
        // 顧客担当者名全角チェック
        id: 'manager',
        rule: ['fullwidth_only']
      },
      {
        // 顧客担当者メールアドレスチェック
        id: 'manager_email',
        rule: ['email']
      },
      {
        // 法人番号チェック(数値13桁固定)
        id: 'corporate_number',
        rule: ['numeric|corporate_number_lengthCheck:13']
      }
    ],
    'customer_valid_delete': [
      // {
      //   //電話番号書式チェック
      //   id: 'telephone_number',
      //   rule: ['wrong_format_for_telephone_number']
      // }
    ]
  }
};

/**
 * 顧客部署マスタルール
 */
export const customerDepartmentRules: { [k: string]: { [k: string]: Rules[] } } = {
  'customerdepart_regist': {
    'customerdepart_regist': [
      {
        //郵便番号書式チェック
        id: 'postal_code',
        rule: ['wrong_format_for_postal_code']
      },
      {
        //電話番号書式チェック
        id: 'telephone_number',
        rule: ['wrong_format_for_number_and_hyphen']
      },
      {
        //携帯電話番号書式チェック
        id: 'cell_phone_number',
        rule: ['wrong_format_for_number_and_hyphen']
      },
      {
        // 部署名全角チェック
        id: 'department_name',
        rule: ['fullwidth_only']
      },
      {
        // 町村丁番地全角チェック
        id: 'machimura_street_address',
        rule: ['fullwidth_only']
      },
      {
        // ビル建物名全角チェック
        id: 'building_name',
        rule: ['fullwidth_only']
      },
      {
        // 顧客担当者名全角チェック
        id: 'manager',
        rule: ['fullwidth_only']
      },
      {
        // 顧客担当者メールアドレスチェック
        id: 'manager_email',
        rule: ['email']
      },
      {
        // 部署名カナ全角カナチェック
        id: 'department_name_kana',
        rule: ['fullwidth_katakana_and_space_only']
      }
    ]
  },
  'customerdepart_edit': {
    'customer_department_valid_update': [
      {
        //郵便番号書式チェック
        id: 'postal_code',
        rule: ['wrong_format_for_postal_code']
      },
      {
        //電話番号書式チェック
        id: 'telephone_number',
        rule: ['wrong_format_for_number_and_hyphen']
      },
      {
        //携帯電話番号書式チェック
        id: 'cell_phone_number',
        rule: ['wrong_format_for_number_and_hyphen']
      },
      {
        // 部署名全角チェック
        id: 'department_name',
        rule: ['fullwidth_only']
      },
      {
        // 町村丁番地全角チェック
        id: 'machimura_street_address',
        rule: ['fullwidth_only']
      },
      {
        // ビル建物名全角チェック
        id: 'building_name',
        rule: ['fullwidth_only']
      },
      {
        // 顧客担当者名全角チェック
        id: 'manager',
        rule: ['fullwidth_only']
      },
      {
        // 顧客担当者メールアドレスチェック
        id: 'manager_email',
        rule: ['email']
      },
      {
        // 部署名カナ全角カナチェック
        id: 'department_name_kana',
        rule: ['fullwidth_katakana_and_space_only']
      }
    ],
    'customer_department_valid_delete': [
      // {
      //   id: 'department_name',
      //   rule: ['required']
      // }
    ]
  }
};

export const orderRules: { [k: string]: { [k: string]: Rules[] } } = {
  // 発注登録時
  'order_regist': {
    'order_regist': [
      {
        id: 'delivery_limit_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'order_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'delivery_limit_date', rule: 'chk_max_date', addValue: true },
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      }
    ],
    'order_detail_regist': [
      {
        id: 'item_id',
        rule: []
      },
      {
        id: 'order_quantity',
        rule: ['integer']
      },
      {
        id: 'unit_id',
        rule: ['selectRequired']
      },
      {
        id: 'amount',
        rule: []
      },
      {
        id: 'tax',
        rule: []
      },
      {
        id: 'tax_class_id',
        rule: ['selectRequired']
      },
      {
        id: 'unit_price',
        rule: ['integer_greater_than_zero']
      }
    ]
  },
  // 発注申請作成中ステータス
  'order_preparing': {
    'order_preparing_apply': [
      {
        id: 'delivery_limit_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'order_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'delivery_limit_date', rule: 'chk_max_date', addValue: true },
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      }
    ],
    'order_preparing_edit': [
      {
        id: 'delivery_limit_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'order_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'delivery_limit_date', rule: 'chk_max_date', addValue: true },
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      }
    ],
    'order_detail_preparing_apply': [
      {
        id: 'item_id',
        rule: []
      },
      {
        id: 'order_quantity',
        rule: ['integer']
      },
      {
        id: 'unit_id',
        rule: ['selectRequired']
      },
      {
        id: 'amount',
        rule: []
      },
      {
        id: 'tax',
        rule: []
      },
      {
        id: 'tax_class_id',
        rule: ['selectRequired']
      },
      {
        id: 'unit_price',
        rule: ['integer_greater_than_zero']
      }
    ],
    'order_detail_preparing_edit': [
      {
        id: 'item_id',
        rule: []
      },
      {
        id: 'order_quantity',
        rule: ['integer']
      },
      {
        id: 'unit_id',
        rule: ['selectRequired']
      },
      {
        id: 'amount',
        rule: []
      },
      {
        id: 'tax',
        rule: []
      },
      {
        id: 'tax_class_id',
        rule: ['selectRequired']
      },
      {
        id: 'unit_price',
        rule: ['integer_greater_than_zero']
      }
    ]
  },
  // 発注申請済ステータス
  'order_applied': {
    'order_applied_approve': [
      {
        id: 'delivery_limit_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'order_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'delivery_limit_date', rule: 'chk_max_date', addValue: true },
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      }
    ],
    'order_applied_edit': [
      {
        id: 'delivery_limit_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'order_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'delivery_limit_date', rule: 'chk_max_date', addValue: true },
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      }
    ],
    'order_detail_applied_approve': [
      {
        id: 'item_id',
        rule: []
      },
      {
        id: 'order_quantity',
        rule: ['integer']
      },
      {
        id: 'unit_id',
        rule: ['selectRequired']
      },
      {
        id: 'amount',
        rule: []
      },
      {
        id: 'tax',
        rule: []
      },
      {
        id: 'tax_class_id',
        rule: ['selectRequired']
      },
      {
        id: 'unit_price',
        rule: ['integer_greater_than_zero']
      }
    ],
    'order_detail_applied_edit': [
      {
        id: 'item_id',
        rule: []
      },
      {
        id: 'order_quantity',
        rule: ['integer']
      },
      {
        id: 'unit_id',
        rule: ['selectRequired']
      },
      {
        id: 'amount',
        rule: []
      },
      {
        id: 'tax',
        rule: []
      },
      {
        id: 'tax_class_id',
        rule: ['selectRequired']
      },
      {
        id: 'unit_price',
        rule: ['integer_greater_than_zero']
      }
    ]
  },
  // 現場承認済みステータス
  'order_approved': {
    'order_approved_decide': [
      {
        id: 'delivery_limit_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'order_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'delivery_limit_date', rule: 'chk_max_date', addValue: true },
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      }
    ],
    'order_approved_edit': [
      {
        id: 'delivery_limit_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'order_date',
        rule: ['chk_after_the_day'],
        referenceField: [
          { id: 'delivery_limit_date', rule: 'chk_max_date', addValue: true },
          { id: 'order_application_date', rule: 'chk_min_date', addValue: true },
          { id: 'order_application_department_id', rule: 'required', addValue: false }
        ]
      }
    ],
    'order_detail_approved_decide': [
      {
        id: 'item_id',
        rule: []
      },
      {
        id: 'order_quantity',
        rule: ['integer']
      },
      {
        id: 'unit_id',
        rule: ['selectRequired']
      },
      {
        id: 'amount',
        rule: []
      },
      {
        id: 'tax',
        rule: []
      },
      {
        id: 'tax_class_id',
        rule: ['selectRequired']
      },
      {
        id: 'unit_price',
        rule: ['integer_greater_than_zero']
      }
    ],
    'order_detail_approved_edit': [
      {
        id: 'item_id',
        rule: []
      },
      {
        id: 'order_quantity',
        rule: ['integer']
      },
      {
        id: 'unit_id',
        rule: ['selectRequired']
      },
      {
        id: 'amount',
        rule: []
      },
      {
        id: 'tax',
        rule: []
      },
      {
        id: 'tax_class_id',
        rule: ['selectRequired']
      },
      {
        id: 'unit_price',
        rule: ['integer_greater_than_zero']
      }
    ]
  },
  // 発注決裁済ステータス
  'order_decided': {},
  // 発注発信済ステータス
  'order_sent': {},
  // 削除済ステータス
  'order_deleted': {}
}
// 発注アクションで全てReadOnlyにするアクション
export const orderApplyAbove = [
  'order_preparing_apply',
  'order_applied_approve',
  'order_approved_decide',
  'order_decided_send',
  'order_applied_pull_back',
  'order_applied_push_back',
  'order_approved_pull_back',
  'order_approved_push_back',
  'order_preparing_delete'
];

// 上への申請アクション
export const orderAppealAction = [
  'order_applied_approve',
  'order_approved_decide',
  'order_decided_send'
];

export const paymentRules: { [k: string]: { [k: string]: Rules[] } } = {
  // 支払登録済みステータス
  'payment_entry_registered': {
    'payment_entry_registered_request_apply': [
    ],
    'payment_entry_registered_edit': [
    ],
  },
  // 支払依頼申請済ステータス
  'payment_entry_request_applied': {
    'payment_entry_request_applied_approve': [
    ],
    'payment_entry_request_applied_edit': [
    ]
  },
  // 支払依頼承認済ステータス
  'payment_entry_request_approved': {
    'payment_entry_request_approved_decision_approve': [
    ],
    'payment_entry_request_approved_edit': [
    ]
  },
  // 支払決裁承認済ステータス
  'payment_entry_decision_approved': {}
}
// 支払依頼アクションで全てReadOnlyにするアクション
export const paymentApplyAbove = [
  'payment_entry_registered_request_apply',
  'payment_entry_request_applied_approve',
  'payment_entry_request_approved_decision_approve',
  'payment_entry_request_approved_push_back',
  'payment_entry_decision_approved_push_back'
];

export const purchaseRules: { [k: string]: { [k: string]: Rules[] } } = {
  // 購買要件登録時
  'purchase_regist': {
    'purchase_regist': [
      {
        id: 'purchase_requirement_date',
        rule: ['chk_max_date'],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: ['chk_max_date'],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: ['chk_max_date'],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: ['chk_min_date'],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: ['chk_max_date'],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'purchase_detail_regist': [
      {
        id: 'item_id',
        rule: []
      },
      {
        id: 'order_quantity',
        rule: ['integer']
      },
      {
        id: 'unit_id',
        rule: ['selectRequired']
      },
      {
        id: 'amount',
        rule: []
      },
      {
        id: 'tax',
        rule: []
      },
      {
        id: 'tax_class_id',
        rule: ['selectRequired']
      },
      {
        id: 'unit_price',
        rule: ['integer_greater_than_zero']
      }
    ]
  },

  // 購買要件詳細画面
  // 購買要件作成中
  'order_purchase_preparing': {
    'order_purchase_preparing_edit': [
      {
        id: 'purchase_requirement_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'order_purchase_preparing_apply': [
      {
        id: 'purchase_requirement_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'order_detail_purchase_preparing_edit': [
      {
        id: 'item_id',
        rule: []
      },
      {
        id: 'order_quantity',
        rule: ['integer']
      },
      {
        id: 'unit_id',
        rule: ['selectRequired']
      },
      {
        id: 'amount',
        rule: []
      },
      {
        id: 'tax',
        rule: []
      },
      {
        id: 'tax_class_id',
        rule: ['selectRequired']
      },
      {
        id: 'unit_price',
        rule: ['integer_greater_than_zero']
      }
    ],
    'order_detail_purchase_preparing_apply': [
      {
        id: 'item_id',
        rule: []
      },
      {
        id: 'order_quantity',
        rule: ['integer']
      },
      {
        id: 'unit_id',
        rule: ['selectRequired']
      },
      {
        id: 'amount',
        rule: []
      },
      {
        id: 'tax',
        rule: []
      },
      {
        id: 'tax_class_id',
        rule: ['selectRequired']
      },
      {
        id: 'unit_price',
        rule: ['integer_greater_than_zero']
      }
    ]
  },
  // 購買見積依頼申請済
  'order_purchase_estimate_request_applied': {
    'order_purchase_estimate_request_applied_edit': [
      {
        id: 'purchase_requirement_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'order_purchase_estimate_request_applied_approve': [
      {
        id: 'purchase_requirement_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'order_detail_purchase_estimate_request_applied_edit': [
      {
        id: 'item_id',
        rule: []
      },
      {
        id: 'order_quantity',
        rule: ['integer']
      },
      {
        id: 'unit_id',
        rule: ['selectRequired']
      },
      {
        id: 'amount',
        rule: []
      },
      {
        id: 'tax',
        rule: []
      },
      {
        id: 'tax_class_id',
        rule: ['selectRequired']
      },
      {
        id: 'unit_price',
        rule: ['integer_greater_than_zero']
      }
    ],
    'order_detail_purchase_estimate_request_applied_approve': [
      {
        id: 'item_id',
        rule: []
      },
      {
        id: 'order_quantity',
        rule: ['integer']
      },
      {
        id: 'unit_id',
        rule: ['selectRequired']
      },
      {
        id: 'amount',
        rule: []
      },
      {
        id: 'tax',
        rule: []
      },
      {
        id: 'tax_class_id',
        rule: ['selectRequired']
      },
      {
        id: 'unit_price',
        rule: ['integer_greater_than_zero']
      }
    ]
  },
  // 購買見積依頼承認済
  'order_purchase_estimate_request_approved': {
    'order_purchase_estimate_request_approved_send': [
      {
        id: 'purchase_requirement_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'order_detail_purchase_estimate_request_approved_send': []
  },
  // 見積依頼中
  'order_estimate_requesting': {
    'order_estimate_requesting_edit': [
      {
        id: 'purchase_requirement_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'order_estimate_requesting_register': [
      {
        id: 'purchase_requirement_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'order_estimate_detail_requesting_edit': [],
    'order_estimate_detail_requesting_register': []
  },
  // 見積登録済
  'order_estimate_registered': {
    'order_estimate_registered_edit': [
      {
        id: 'purchase_requirement_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'order_estimate_registered_apply': [
      {
        id: 'purchase_requirement_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'order_estimate_detail_registered_edit': [],
    'order_estimate_detail_registered_apply': []
  },
  // 購買発注依頼申請済
  'order_purchase_order_request_applied': {
    'order_purchase_order_request_applied_edit': [
      {
        id: 'purchase_requirement_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'order_purchase_order_request_applied_approve': [
      {
        id: 'purchase_requirement_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'order_detail_purchase_order_request_applied_edit': [],
    'order_detail_purchase_order_request_applied_approve': []
  },
  // 購買発注依頼承認済
  'order_purchase_order_request_approved': {
    'order_purchase_order_request_approved_send': [
      {
        id: 'purchase_requirement_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_deadline_date', rule: 'chk_max_date', addValue: true }
        ]
      },
      {
        id: 'estimate_deadline_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true },
          { id: 'estimate_date', rule: 'required', addValue: false }
        ]
      },
      {
        id: 'delivery_limit_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_min_date', addValue: true }
        ]
      },
      {
        id: 'approval_document_date',
        rule: [],
        referenceField: [
          { id: 'order_plan_date', rule: 'chk_max_date', addValue: true }
        ]
      }
    ],
    'order_detail_purchase_order_request_approved_send': []
  }
}

// 購買要件での上への申請アクション
export const purchaseAppealAction = [
  'order_purchase_estimate_request_applied_approve',
  'order_purchase_order_request_applied_approve'
];

// 購買アクションで全てReadOnlyにするアクション
export const purchaseApplyAbove = [
  'order_purchase_preparing_apply',
  'order_purchase_preparing_delete',
  'order_purchase_estimate_request_applied_approve',
  'order_purchase_estimate_request_applied_pull_back',
  'order_purchase_estimate_request_applied_push_back',
  'order_purchase_estimate_request_approved_send',
  'order_estimate_requesting_register',
  'order_estimate_requesting_delete',
  'order_estimate_registered_apply',
  'order_estimate_registered_delete',
  'order_purchase_order_request_applied_approve',
  'order_purchase_order_request_applied_pull_back',
  'order_purchase_order_request_applied_push_back',
  'order_purchase_order_request_approved_send'
];

export const estimateRules: { [k: string]: { [k: string]: Rules[] } } = {
}

// 見積アクションで全てReadOnlyにするアクション
export const estimateApplyAbove = [
  'estimate_basic_info_OA_temporarily_saved_register',
  'estimate_basic_info_OA_temporarily_saved_delete',
  'estimate_basic_info_OA_registering_confirm',
  'estimate_basic_info_OA_registering_copy',
  'estimate_basic_info_OA_registering_delete',
  'estimate_basic_info_OA_estimate_confirmed_copy',
  'estimate_basic_info_OA_estimate_confirmed_cancel',
  'estimate_basic_info_general_temporarily_saved_register',
  'estimate_basic_info_general_temporarily_saved_delete',
  'estimate_basic_info_general_registering_confirm',
  'estimate_basic_info_general_registering_copy',
  'estimate_basic_info_general_registering_delete',
  'estimate_basic_info_general_estimate_confirmed_copy',
  'estimate_basic_info_general_estimate_confirmed_cancel',
  'estimate_basic_info_fjapan_temporarily_saved_register',
  'estimate_basic_info_fjapan_temporarily_saved_delete',
  'estimate_basic_info_fjapan_registering_confirm',
  'estimate_basic_info_fjapan_registering_copy',
  'estimate_basic_info_fjapan_registering_delete',
  'estimate_basic_info_fjapan_estimate_confirmed_copy',
  'estimate_basic_info_fjapan_estimate_confirmed_cancel'
];